import React, {Fragment} from "react";
import Button from "../Button";
import {default as VoucherPaymentList} from "../../editors/OperationList/Elements/VoucherPayment";

export default class VoucherPayment extends React.Component {
    render() {
        const vouchers = (this.props.option || {}).vouchers || [];
        return (
            <div className="payment voucher-payment">
                <Button
                    color="default"
                    block={true}
                    onClick={() => {
                        this.voucher && this.voucher.focus();
                    }}>
                        {
                            vouchers.length ?
                            <Fragment>
                                {vouchers.length} Utalvány ({vouchers.length ? vouchers.map((voucher) => parseFloat(voucher.amount || voucher.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0")) : 0} Ft)
                            </Fragment> :
                            <Fragment>
                                Kiválasztás
                            </Fragment>
                        }
                    </Button>
                <VoucherPaymentList
                    ref={(cpi) => this.voucher = cpi}
                    selection={vouchers}
                    setSelected={(vouchers) => {
                        let voucherAmount = vouchers.length ? vouchers.map((voucher) => parseFloat(voucher.amount || voucher.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0")) : 0;

                        this.props.setFieldValue(String(this.props.optionIndex) + ".vouchers", vouchers);
                        this.props.setFieldValue(String(this.props.optionIndex) + ".amount", Math.min(voucherAmount, this.props.total - this.props.cost));
                    }}
                />
            </div>
        );
    }
}